import React from 'react';
import {connect, Provider} from "react-redux";
import {getReduxStore} from "../../ReduxStore/store";
import ProductImagesContainer from "./ProductImagesContainer";

function mapStateToProps(state) {
  return {};
}

const Wrapper = connect(mapStateToProps)(ProductImagesContainer);

export default function ProductImagesApp({store, ...props}) {
  return <Provider store={store || getReduxStore()}>
    <Wrapper {...props} />
  </Provider>
}
